import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { LoginService } from 'src/app/login/login.service';
import { UsersService } from 'src/app/users/users.service';
import { EntitiesService } from '../../entities.service';
import { RolesService } from '../../roles/roles.service';
import { ZonesService } from '../../zones/zones.service';
import { HtmlPreviewComponent } from '../html-preview/html-preview.component';
import { TemplatesTypesService } from '../templates-types.service';
import { TemplatesService } from '../templates.service';

@Component({
  selector: 'app-templates-detail',
  templateUrl: './templates-detail.component.html',
  styleUrls: ['./templates-detail.component.scss']
})
export class TemplatesDetailComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public template: any = {};
  public users: any[] = [];
  public zones: any[] = [];
  public roles: any[] = [];
  public selected_zone: any;
  public selected_zones: any[] = [];
  public selected_user: any;
  public selected_users: any[] = [];
  public selected_role: any;
  public selected_roles: any[] = [];

  public templateTypes: any[];
  public entities: any[];

  public zonesPermission: any;

  constructor(
    private templatesService: TemplatesService,
    private zonesService: ZonesService,
    private usersService: UsersService,
    private rolesService: RolesService,
    private templateTypesService: TemplatesTypesService,
    private entitiesService: EntitiesService,
    private loginService: LoginService,

    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.zonesPermission = this.loginService.hasPermission("ZONES_READ");

    var id = this.config.data.id;
    this.loadTemplateTypes();
    if (!id) {
      this.loadEntities();
    }
    this.loadData(id);
  }

  loadTemplateTypes() {
    this.templateTypesService.all({}).subscribe(
      data => {
        this.templateTypes = data.rows;
        if (this.templateTypes.length > 0 && this.template.id == null) {
          this.template.template_type_id = this.templateTypes[0].id;
          this.template.templatetype = this.templateTypes[0];
        }
      }, error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }         
    );
  }
  loadEntities() {
    this.entitiesService.all({}).subscribe(
      data => {
        this.entities = data.rows;
        if (this.entities.length > 0 && this.template.id == null) {
          this.template.entity_id = this.entities[0].id;
        }
      }, error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  loadData(id) {
    if (id) {
      this.templatesService.get(id).subscribe(
        data => {
          this.template = data;
          this.loadMetadata();
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    } else {
      this.template.template_type_id = this.config.data.template_type_id;
    }
  }
  save(event: any) {
    this.buildMetadata();
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.template.id === "undefined") {
      this.template.is_default = 0;
      this.templatesService.add(this.template).subscribe(
        data => {
          this.template = data;
          this.loadData(this.template.id);
          this.messageService.add({ closable: false, severity: 'success', summary: "Plantilla añadida correctamente." });
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.templatesService.save(this.template.id, this.template).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Plantilla guardada correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la plantilla " + this.template.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.templatesService.delete(this.template.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }

  save_permissions(message) {
    this.buildMetadata();
    this.templatesService.savePermissions(this.template.id, this.template).subscribe(
      data => {
        this.messageService.add({ closable: false, severity: 'success', detail: message });
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  save_zone() {
    //Guarda zona en tabla y lo elimina del dropdown.
    if (this.selected_zone != null) {
      this.zones.splice(this.zones.lastIndexOf(this.selected_zone), 1);
      this.selected_zones.push(this.selected_zone);
      this.selected_zone = null;
      this.save_permissions("Zona asignada correctamente.");
    }
  }
  unlinkZone(zone) {
    //Guarda la zona en dropdown y lo elimina de la tabla.
    var erased = this.selected_zones.splice(this.selected_zones.lastIndexOf(zone), 1);
    this.zones.push(erased[0]);
    this.selected_zone = { name: "Selecciona una zona." };
    this.save_permissions("Zona rehusada correctamente");
  }
  save_role() {
    if (this.selected_role != null) {
      this.roles.splice(this.roles.lastIndexOf(this.selected_role), 1);
      this.selected_roles.push(this.selected_role);
      this.selected_role = null;
      this.save_permissions("Rol asignado correctamente.");
    }
  }
  unlinkRole(role) {
    var erased = this.selected_roles.splice(this.selected_roles.lastIndexOf(role), 1);
    this.roles.push(erased[0]);
    this.selected_role = { name: "Selecciona un rol." };
    this.save_permissions("Rol rehusado correctamente");
  }
  save_user() {
    if (this.selected_user != null) {
      this.users.splice(this.users.lastIndexOf(this.selected_user), 1);
      this.selected_users.push(this.selected_user);
      this.selected_user = null;
      this.save_permissions("Usuario asignado correctamente.");
    }
  }
  unlinkUser(user) {
    var erased = this.selected_users.splice(this.selected_users.lastIndexOf(user), 1);
    this.users.push(erased[0]);
    this.selected_user = { name: "Selecciona un usuario." };
    this.save_permissions("Usuario rehusado correctamente");
  }
  buildMetadata() {
    var finalZones = [];
    var finalUsers = [];
    var finalRoles = [];

    this.selected_zones.forEach(zone => {
      finalZones.push(zone.id);
    });
    this.selected_roles.forEach(role => {
      finalRoles.push(role.id);
    });
    this.selected_users.forEach(user => {
      finalUsers.push(user.id);
    });

    this.template.metadata = {
      permissions: {
        zones: finalZones,
        users: finalUsers,
        roles: finalRoles
      }
    }
  }

  loadMetadata() {
    var zonesIds = this.template.metadata["permissions"]["zones"];
    var usersIds = this.template.metadata["permissions"]["users"];
    var rolesIds = this.template.metadata["permissions"]["roles"];

    //Carga la tabla y dropdown de Usuarios:
    this.usersService.combo({}).subscribe(
      data => {
        var tempUsers = [];
        this.users = data.rows;
        this.users.forEach(user => {
          if (usersIds.indexOf(user.id) > -1) {
            this.selected_users.push(user);
          } else {
            tempUsers.push(user);
          }
          this.users = tempUsers;
        });
        /*this.selected_users = this.users.filter(function (e) {
          return usersIds.indexOf(e.id) > -1;
        });*/
      },
      error => {

      }
    );

    //Carga la tabla y dropdown de Zonas:
    if (this.zonesPermission) {

      this.zonesService.combo({}).subscribe(
        data => {
          var tempZones = [];
          this.zones = data.rows;
          this.zones.forEach(zone => {
            if (zonesIds.indexOf(zone.id) > -1) {
              this.selected_zones.push(zone);
            } else {
              tempZones.push(zone);
            }
            this.zones = tempZones;
          });

          /*this.selected_zones = this.zones.filter(function (e) {
            return zonesIds.indexOf(e.id) > -1;
          });*/
        },
        error => {

        }
      );
    }

    /*/Carga la tabla y dropdown de Roles:
    this.rolesService.getComboRoles({rolesIds: rolesIds}).subscribe(
      data=>{
        this.selected_roles = data.filter(function(element){
          return element.selected == true;
        });
        this.roles = data.filter(function(element){
          return element.selected != true;
        });
      }
    );*/
    this.rolesService.combo({}).subscribe(
      data => {
        var tempRoles = [];
        this.roles = data.rows;
        this.roles.forEach(role => {
          if (rolesIds.indexOf(role.id) > -1) {
            this.selected_roles.push(role);
          } else {
            tempRoles.push(role);
          }
          this.roles = tempRoles;
        });
        /*this.selected_roles = this.roles.filter(function (e) {
          return rolesIds.indexOf(e.id) > -1;
        });*/
      },
      error => {

      }
    );
  }

  previewHTML() {

    const ref = this.dialogService.open(HtmlPreviewComponent, {
      data: {
        temporal_template: this.template,
        entity_id: this.template.entity_id,
        entity_pk_id: 1
      },
      header: "Previsualizado",
      width: '70%',
    });
    ref.onClose.subscribe((data: any) => {
    });
  }

  isDuplied(event) {
    if (this.template.id == null) {
      this.template.html = "<p></p>";
    }
    this.template.templatetype = null;
    //if (this.template.templatetype?.code != "MAIL") this.template.subject = null;
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.templatesService.isDuplied(this.template).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe una plantilla con estos datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save(event);
        }
      },
      error => {
        var message = "";
        for (var [key, value] of Object.entries(error.error.errors)) {
          message += value[0] + "\n\t";
        }
        if (message == "") message = error.error.title;
        this.messageService.add({ closable: false, severity: "error", detail: message });
      }
    );
  }
  duplicateTemplate() {
    //GUARDAMOS y Duplicamos la líneas de notification_to y notification_email.
    this.templatesService.save(this.template.id, this.template).subscribe(
      data => {

        this.templatesService.duplicateTemplate(this.template.id).subscribe(
          data => {
            this.dynamicDialogRef.close();
            let template_new = data;
            const ref = this.dialogService.open(TemplatesDetailComponent, {
              data: {
                id: template_new != null ? template_new.id : null,
                template_type_id: template_new.template_type_id
              },
              header: template_new != null ? 'Modificar plantilla' : 'Añadir plantilla',
              width: '70%'
            });
            ref.onClose.subscribe((data: any) => {
              this.view.fireEvent("templates.list.results", "reload");
            });
          });
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    )

  }

  /*changeCode(templatetype) {
    this.template.templatetype = templatetype;
    if (templatetype.code == "DOCUMENT") this.template.subject = "";
  }
  */
  onEvent(event) {

    if (event.component == "templates.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(event);
      if (event.event == "action" && event.action.name == "preview") this.previewHTML();
      if (event.event == "action" && event.action.name == "duplicate") this.duplicateTemplate();
      if (event.event == "onChange" && event.entityField?.model_property == "template_type_id") {
        
        //console.log(event.data.template_type_id, (this.templateTypes.filter(m => m.id == event.data.template_type_id)[0]), this.template.templatetype, this.templateTypes)
        //this.changeCode(this.templateTypes.filter(m => m.id == event.data.template_type_id)[0]);
      }
    }


    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.template.id) !== "undefined" ? "Detalles de la " + this.view.getEntityBaseName() : "Nueva " + this.view.getEntityBaseName();
    }
  }
}
